/*
 *  全系列 restful api格式, 定义通用req对象
 *
 *  @author terrfly
 *  @site https://www.jeepay.vip
 *  @date 2021/5/8 07:18
 */

import request from '@/http/request'

/** 首页统计 **/
export const API_URL_MAIN_STATISTIC = '/api/mainChart'

const api = {
  user: '/user',
  role_list: '/role',
  service: '/cost',
  permission: '/permission',
  permissionNoPager: '/permission/no-pager',
  orgTree: '/org/tree'
}

export default api

/** 获取权限树状结构图 **/
export function getEntTree () {
  return request.request({ url: '/api/sysEnts/showTree', method: 'GET' })
}

/** 更新用户角色信息 */
export function uSysUserRoleRela (sysUserId, roleIdList) {
  return request.request({
    url: '/api/sysUserRoleRelas/relas/' + sysUserId,
    method: 'POST',
    data: { roleIdListStr: JSON.stringify(roleIdList) }
  })
}

export function getRoleList (parameter) {
  return request({
    url: '/api/sysRoles',
    method: 'get',
    params: parameter
  })
}

/** 根据支付接口查询支付参数配置 **/
export function getMchPayConfigUnique (infoId, ifCode) {
  return request.request({
    url: '/api/mch/payConfigs/' + infoId + '/' + ifCode,
    method: 'get'
  })
}

//order_checksn
export function order_checksn (parameter) {
  return request.request({
    url: '/api/order/checksn',
    method: 'POST',
    data: parameter
  })
}

/** 支付体验配置 **/
export function payTest (appId) {
  return request.request({
    url: '/api/paytest/payways/' + appId,
    method: 'GET'
  })
}

// minio/download
export function miniodownload (appId) {
  return request.request({
    url: '/minio/download?url=' + appId,
    responseType: 'blob',
    method: 'get'
  })
}

export function getpricelist (parameter) {
    return request.request({
        url: '/api/price/getprice',
        method: 'POST',
        data: parameter
    })
}

export function checkorderstatus (parameter) {
  return request.request({
    url: '/api/order/checkorderstatus',
    method: 'POST',
    data: parameter
  })
}

//抠章服务支付
export function paysealorder (parameter) {
  return request.request({
    url: '/api/order/payseal',
    method: 'POST',
    data: parameter
  })
}

/** 支付体验下单配置 **/
export function payTestOrder (parameter) {
  return request.request({
    url: '/api/order/pay',
    method: 'POST',
    data: parameter
  })
}
//api/conf/list   配置项管理
export function conf_list (parameter) {
  return request.request({
    url: '/api/conf/list',
    method: 'POST',
    data: parameter
  })
}

// getInfo
export function getInfo (parameter) {
  return request.request({
    url: '/getInfo',
    method: 'GET',
    data: parameter
  })
}

// cardPrice/priceList
export function cardPrice_priceList (parameter) {
  return request.request({
    url: '/cardPrice/priceList',
    method: 'POST',
    data: parameter
  })
}

// api/price/getPriceByfuwu
export function getPriceByfuwu (parameter) {
  return request.request({
    url: '/api/price/getPriceByfuwu',
    method: 'POST',
    data: parameter
  })
}

//card/getUseCompany
export function card_getUseCompany (parameter) {
  return request.request({
    url: '/card/getUseCompany',
    method: 'POST',
    data: parameter
  })
}

// /api/order/payrecharge
export function getPriceByfuwu_payrecharge (parameter) {
  return request.request({
    url: '/api/order/payrecharge',
    method: 'POST',
    data: parameter
  })
}



export function refund_getrestnum (parameter) {
  return request.request({
    url: '/api/refund/getrestnum',
    method: 'POST',
    data: parameter
  })
}

export function SF_query_by_expressno(parameter) {
  return request.request({
    url: '/sf/query_by_expressno',
    method: 'POST',
    data: parameter
  })
}


export function getsealprice (parameter) {
  return request.request({
    url: '/api/price/getsealprice',
    method: 'POST',
    data: parameter
  })
}

/** 价格单价 **/
export function price_getPrice (parameter) {
  return request.request({
    url: '/api/price/getPrice',
    method: 'POST',
    data: parameter
  })
}
//api/price/getPriceBydaiban
export function getPriceBydaiban (parameter) {
  return request.request({
    url: '/api/price/getPriceBydaiban',
    method: 'POST',
    data: parameter
  })
}

//api/price/getPriceByyouji
export function price_getPriceByyouji (parameter) {
  return request.request({
    url: '/api/price/getPriceByyouji',
    method: 'POST',
    data: parameter
  })
}
//order/orderList /** 价格xiuhai 单价 **/
export function order_orderList (parameter) {
  return request.request({
    url: '/api/order/orderList',
    method: 'POST',
    data: parameter
  })
}


///company/servicetime
export function company_servicetime (parameter) {
  return request.request({
    url: '/api/order/getTime',
    method: 'POST',
    data: parameter
  })
}

// /system/user/register
export function user_register (parameter) {
  return request.request({
    url: '/extend/user/register',
    method: 'POST',
    data: parameter
  })
}



/** 根据支付方式查询可用支付接口 **/
export function getAvailablePayInterfaceList (appId, wayCode) {
  return request.request({
    url: '/api/mch/payPassages/availablePayInterface/' + appId + '/' + wayCode,
    method: 'GET'
  })
}

export function getPayAmountWeek () {
  return request.request({
    url: API_URL_MAIN_STATISTIC + '/payAmountWeek',
    method: 'GET'
  })
}

export function getNumCount () {
  return request.request({
    url: API_URL_MAIN_STATISTIC + '/numCount',
    method: 'GET'
  })
}

export function getPayCount (parameter) {
  return request.request({
    url: API_URL_MAIN_STATISTIC + '/payCount',
    method: 'GET',
    params: parameter
  })
}

export function getPayType (parameter) {
  return request.request({
    url: API_URL_MAIN_STATISTIC + '/payTypeCount',
    method: 'GET',
    params: parameter
  })
}

export function getMainUserInfo () {
  return request.request({
    url: API_URL_MAIN_STATISTIC,
    method: 'GET'
  })
}

export function updateUserPass (parameter) {
  return request.request({
    url: '/api/current/modifyPwd',
    method: 'put',
    data: parameter
  })
}


// api/order/makestamp
export function order_makestamp (parameter) {
  return request.request({
    url: '/api/order/makestamp',
    method: 'POST',
    data: parameter
  })
}

export function updateUserInfo (parameter) {
  return request.request({
    url: '/api/current/user',
    method: 'put',
    data: parameter
  })
}

export function getUserInfo () {
  return request.request({
    url: '/api/current/user',
    method: 'get'
  })
}

// api/order/downloadstamp

export function api_order_downloadstamp (appId, wayCode) {
  return request.request({
    url: '/api/order/downloadstamp?sealcode=' + appId + '&image=' + wayCode,
    method: 'GET'
  })
}

/** 获取到webSocket的前缀 （ws://localhost） **/
export function getWebSocketPrefix () {
  // 获取网站域名 +  端口号
  let domain = document.location.protocol + '//' + document.location.host

  // 判断api_base_url 是否设置
  if (process.env.VUE_APP_API_BASE_URL && process.env.VUE_APP_API_BASE_URL !== '/') {
    domain = process.env.VUE_APP_API_BASE_URL
  }

  if (domain.startsWith('https:')) {
    return 'wss://' + domain.replace('https://', '')
  } else {
    return 'ws://' + domain.replace('http://', '')
  }
}

/** 查询支付宝授权地址URL **/
export function queryAlipayIsvsubMchAuthUrl (mchAppId) {
  return request.request({
    url: '/api/mch/payConfigs/alipayIsvsubMchAuthUrls/' + mchAppId,
    method: 'GET'
  })
}

/** 查询商户转账支出的接口 **/
export function queryMchTransferIfCode (appId) {
  return request.request({
    url: '/api/mchTransfers/ifCodes/' + appId,
    method: 'GET'
  })
}

/** 获取渠道用户ID二维码地址 **/
export function getChannelUserQrImgUrl (ifCode, appId, extParam) {
  return request.request({
    url: '/api/mchTransfers/channelUserId',
    method: 'GET',
    params: { ifCode, appId, extParam }
  })
}

/** 转账 **/
export function doTransfer (parameter) {
  return request.request({
    url: '/api/mchTransfers/doTransfer',
    method: 'POST',
    data: parameter
  }, true, true, true)
}

/** 查询当前应用支持的支付接口 **/
export function getIfCodeByAppId (appId) {
  return request.request({
    url: '/api/mch/payConfigs/ifCodes/' + appId,
    method: 'GET'
  }, true, true, true)
}

/** 退款接口 */
export function payOrderRefund (payOrderId, refundAmount, refundReason) {
  return request.request({
    url: '/api/payOrder/refunds/' + payOrderId,
    method: 'POST',
    data: { refundAmount, refundReason }
  })
}

/** 分账重试 */
export function resendDivision (recordId) {
  return request.request({
    url: '/api/division/records/resend/' + recordId,
    method: 'POST'
  })
}

//mail_send
export function sendloginemail(data) {
  return request.request({
    url: '/api/mail/sendloginemail',
    method: 'post',
    data
  })
}

// sms/sendSms
export function sms_sendSms(data) {
  return request.request({
    url: '/api/sms/sendSms',
    method: 'post',
    data
  })
}


//mail_send
export function mail_send(data) {
  return request.request({
    url: '/api/mail/send',
    method: 'post',
    data
  })
}



export function userlogin(data) {
  return request.request({
    url: '/login',
    method: 'post',
    data
  })
}
// mallOrderdata/selectlist
export function mallOrderdata_selectlist(data) {
  return request.request({
    url: '/mallOrderdata/selectlist',
    method: 'post',
    data
  })
}


//order_orderlist
export function order_orderlist(data) {
  return request.request({
    url: '/api/order/orderlist',
    method: 'post',
    data
  })
}

//order/applyContract 生成合同
export function order_applyContract(data) {
  return request.request({
    url: '/api/order/applyContract',
    method: 'post',
    data
  })
}

//refund/refund
export function refund_refund(data) {
  return request.request({
    url: '/api/refund/refund',
    method: 'post',
    data
  })
}

// mallOrderdata/getrestnum
export function mallOrderdata_getrestnum(data) {
  return request.request({
    url: '/mallOrderdata/getrestnum',
    method: 'post',
    data
  })
}

// mallOrderdata/apply_refund  退款
export function mallOrderdata_apply_refund(data) {
  return request.request({
    url: '/mallOrderdata/apply_refund',
    method: 'post',
    data
  })
}


//  api/order/paywaitpay
export function order_paywaitpay(data) {
  return request.request({
    url: '/api/order/paywaitpay',
    method: 'post',
    data
  })
}



export function login_userlogin (parameter) {
  return request.request({
    url: '/api/login/userLogin',
    method: 'POST',
    data: parameter
  })
}

export function login(data) {
  return request({
    url: '/api/login/userLogin',
    method: 'post',
    data
  })
}


// api/mail/sendByCw
export function mail_sendByCw(data) {
  return request.request({
    url: '/api/mail/sendByCw',
    method: 'post',
    data
  })
}

//api/refund_orderList
export function refund_orderList(data) {
  return request.request({
    url: '/api/refund/orderList',
    method: 'post',
    data
  })
}

//refund/audit
export function refund_audit(data) {
  return request.request({
    url: '/api/refund/audit',
    method: 'post',
    data
  })
}



//mallOrderdata/update_user_info  修改用户信息
export function mallOrderdata_update_user_info(data) {
  return request.request({
    url: '/mallOrderdata/update_user_info',
    method: 'post',
    data
  })
}


//mail_send_email_code  验证码
export function mail_send_email_code(data) {
  return request.request({
    url: '/api/mail/send_email_code',
    method: 'post',
    data
  })
}


//mallOrderdata/update_user_password  修改密码
export function mallOrderdata_update_user_password(data) {
  return request.request({
    url: '/mallOrderdata/update_user_password',
    method: 'post',
    data
  })
}

//card/selectlist
export function card_selectlist(data) {
  return request.request({
    url: '/card/selectlist',
    method: 'post',
    data
  })
}

//api/order/paycard
export function order_paycard(data) {
  return request.request({
    url: '/api/order/paycard',
    method: 'post',
    data
  })
}

/** 获取渠道用户ID二维码地址 **/
export function mallOrderdata_download_seal (filename) {
  return request.request({
    url: '/mallOrderdata/download_seal?filename='+filename,
    method: 'GET',
    responseType: 'blob'
  })
}


// mallOrderdata/deal_seal_list
export function mallOrderdata_deal_seal_list(data) {
  return request.request({
    url: '/mallOrderdata/deal_seal_list',
    method: 'post',
    data
  })
}

// mallOrderdata/delete_mallOrderdata
export function mallOrderdata_delete_mallOrderdata(data) {
  return request.request({
    url: '/mallOrderdata/delete_mallOrderdata',
    method: 'post',
    data
  })
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// 首页统计
export function card_getCardCountByYys(data) {
  return request.request({
    url: '/card/getCardCountByYys',
    method: 'post',
    data
  })
}

// 终端的图表接口 terminal/getCardCountByStatus
export function terminal_getCardCountByStatus(data) {
  return request.request({
    url: '/terminal/getCardCountByStatus',
    method: 'post',
    data
  })
}


//轮播图 banner/active_list
export function banner_active_list(data) {
  return request.request({
    url: '/banner/active_list',
    method: 'post',
    data
  })
}

//通知公告 content/contentlist
export function content_contentlist(data) {
  return request.request({
    url: '/content/contentlist',
    method: 'post',
    data
  })
}

//知识库 knowledge/queryknowledgelist
export function knowledge_queryknowledgelist(data) {
  return request.request({
    url: '/knowledge/queryknowledgelist',
    method: 'post',
    data
  })
}

//card/getTopCards   网卡列表
export function card_getTopCards(data) {
  return request.request({
    url: '/card/getTopCards',
    method: 'post',
    data
  })
}

//terminal/selectlist   终端列表
export function terminal_selectlist(data) {
  return request.request({
    url: '/terminal/selectlist',
    method: 'post',
    data
  })
}

//卡到期预警 card/expiring_cards
export function card_expiring_cards(data) {
  return request.request({
    url: '/card/expiring_cards',
    method: 'post',
    data
  })
}

//终端到期预警 terminal/expiring_terminals
export function terminal_expiring_terminals(data) {
  return request.request({
    url: '/terminal/expiring_terminals',
    method: 'post',
    data
  })
}


//cardPrice/priceList   折扣列表
// export function cardPrice_priceList(data) {
//   return request.request({
//     url: '/cardPrice/priceList',
//     method: 'post',
//     data
//   })
// }


//申请开票 /cardInvoice/add_cardInvoice
export function cardInvoice_Add_cardInvoice(data) {
  return request.request({
    url: '/cardInvoice/add_cardInvoice',
    method: 'post',
    data
  })
}
//开票列表 /cardInvoice/cardInvoiceList
export function cardInvoice_CardInvoiceList(data) {
  return request.request({
    url: '/cardInvoice/cardInvoiceList',
    method: 'post',
    data
  })
}





/** 发票抬头 - 查询列表 */
export function invoiceTitle_selectlist(data) {
  return request.request({
    url: '/orderInvoiceTitle/selectlist',
    method: 'post',
    data
  })
}

/** 发票抬头 - 新增 */
export function invoiceTitle_add(data) {
  return request.request({
    url: '/orderInvoiceTitle/add_orderInvoiceTitle',
    method: 'post',
    data
  })
}

/** 发票抬头 - 修改 */
export function invoiceTitle_update(data) {
  return request.request({
    url: '/orderInvoiceTitle/update_orderInvoiceTitle',
    method: 'post',
    data
  })
}

/** 发票抬头 - 删除 */
export function invoiceTitle_delete(data) {
  return request.request({
    url: '/orderInvoiceTitle/delete_orderInvoiceTitle',
    method: 'post',
    data
  })
}

/** 单位名称搜索 */
export function company_search(data) {
  return request.request({
    url: '/orderInvoice/company_search',
    method: 'post',
    data
  })
}

/** 开票记录 - 查询列表 */
export function orderInvoice_selectlist(data) {
  return request.request({
    url: '/orderInvoice/selectlist',
    method: 'post',
    data
  })
}

/** 开票记录 - 新增 */
export function orderInvoice_add(data) {
  return request.request({
    url: '/orderInvoice/add_orderInvoice',
    method: 'post',
    data
  })
}

/** 开票记录 - 修改 */
export function orderInvoice_update(data) {
  return request.request({
    url: '/orderInvoice/update_orderInvoice',
    method: 'post',
    data
  })
}

/** 开票记录 - 删除 */
export function orderInvoice_delete(data) {
  return request.request({
    url: '/orderInvoice/delete_orderInvoice',
    method: 'post',
    data
  })
}

/** 查询发票 - /invoice/query_invoice?orderId=id */
export function invoice_query(data) {
  return request.request({
    url: '/invoice/query_invoice',
    method: 'get',
    params: { orderId: data.orderId }
  })
}
